import { FETCH_ACC_CONTACTS_FAILURE, FETCH_ACC_CONTACTS_REQUEST, FETCH_ACC_CONTACTS_SUCCESS } from "../actions/accountContactsActions";
import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";

  const initialState = {
    account_contacts: {'records': [], filters: {}},
    account_contacts_loading: false,
    account_contacts_error: null,
  };
  
  const accountContactsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ACC_CONTACTS_REQUEST:
        return { ...state, account_contacts_loading: true , payload: action.payload};
      case FETCH_ACC_CONTACTS_SUCCESS:
        return { ...state, account_contacts_loading: false, account_contacts: action.payload };
      case FETCH_ACC_CONTACTS_FAILURE:
        return { ...state, account_contacts_loading: false, account_contacts_error: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return { ...state, account_contacts_loading: false, account_contacts: {'records': [], filters: {}} };  
      default:
        return state;
    }
  };
  
  export default accountContactsReducer;
  